import { h } from 'preact';
import CurrentCompact from './current-compact';
import CurrentMini from './current-mini';
import CurrentFull from './current-full';


const isCelsius = (unit) => unit === 'C' || unit === 'c';


/**
 * Render the Current Weather component
 * @param  {string} displayMode   	((full || null) - Full widget || compact - compact view || mini - mini top bar
 * @param  {Object} today         	Current weather information
 * @param  {string} unit          	Temperature units in use 'C' or 'F'
 * @param  {Function} changeUnit  	Callback for updating the unit type used
 * @param  {string} theme         	BG theme (light or dark)
 * @param  {Object} trackingParams	Config info for external link's utm_* query parameters
 * @return {string}               	The rendered component
 */
const Current = ({ displayMode, today, airQuality, unit = 'F', changeUnit, theme, trackingParams }) => {
	if (!today) {
		return;
	}

	const isCelsiusUnit = isCelsius(unit);

	return (
		<div>
			{(displayMode === 'compact') &&
				<CurrentCompact today={today} unit={unit} isCelsius={isCelsiusUnit} theme={theme} />
			}
			{(displayMode === 'mini') &&
				<CurrentMini today={today} unit={unit} isCelsius={isCelsiusUnit} theme={theme} />
			}
			{(!displayMode || displayMode === 'full') &&
				<CurrentFull today={today} airQuality={airQuality} unit={unit} isCelsius={isCelsiusUnit}
					changeUnit={changeUnit} theme={theme} trackingParams={trackingParams}
				/>
			}
		</div>
	);
};
export default Current;
